import React from 'react';
import MainRouter from './router';
// import io from 'socket.io-client';
import { ThemeProvider } from '@mui/material';
import { AuthProvider } from 'context/login';
import { UserProvider } from 'context/user';
import { StepperProvider } from 'context/create-movement';
import { subscribeUser } from './subscription';
import theme from './muiTheme';
import 'bootstrap/scss/bootstrap.scss';
import 'bootstrap/dist/js/bootstrap.js';
import './App.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// socket code for chat handle

// const socket = io.connect('http://localhost:3001');
const socket = ''; // for test

// *for enable notification
<button onClick={subscribeUser}>Click Here</button>


function App() {
    return (
        <div className="paddingBottom">
            <AuthProvider>
                <UserProvider>
                    <StepperProvider>
                        <ThemeProvider theme={theme}>
                            <MainRouter socket={socket} />
                        </ThemeProvider>
                    </StepperProvider>
                </UserProvider>
            </AuthProvider>
        </div>
    );
}

export default App;
